const comp_message_slider = document.getElementById("comp-message-slider");

if (comp_message_slider) {
  const message_swiper = comp_message_slider.querySelector("swiper-container");
  const nav_prev = comp_message_slider.querySelector(".nav.prev");
  const nav_next = comp_message_slider.querySelector(".nav.next");

  const swiper_params = {
    slidesPerView: 1,
    spaceBetween: 100,
    loop: true,
    speed: 500,
    grabCursor: true,
    pagination: true,
    navigation: {
      prevEl: nav_prev,
      nextEl: nav_next,
    },
  };

  swiper_init(message_swiper, swiper_params);
}
